import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { makeLabel } from "@/forms/helpers";
import { cn } from "@/lib/utils";
import { FormFieldError } from "@/forms/form-field-error";
import { Control, ControllerRenderProps, FieldError } from "react-hook-form";
import { ReactNode } from "react";

export const FieldWrapper = ({
  field,
  control,
  disabled = false,
  shouldRenderLabel = true,
  renderComponent,
  labelClassName,
  wrapperClassName,
}: {
  field: Field;
  wrapperClassName?: string;
  control: Control<any>;
  disabled?: boolean;
  shouldRenderLabel?: boolean;
  renderComponent: (
    formField: ControllerRenderProps<any>,
    error: FieldError | undefined,
  ) => ReactNode;
  labelClassName?: string;
}) => {
  return (
    <div className={cn("w-full", wrapperClassName)}>
      <FormField
        control={control}
        disabled={disabled || field.disabled}
        name={field.name as string}
        render={({ field: formField, fieldState: { error } }) => {
          return (
            <FormItem>
              {shouldRenderLabel && field.label && (
                <FormLabel
                  htmlFor={field.name}
                  dangerouslySetInnerHTML={{ __html: makeLabel(field) }}
                  className={cn(
                    "mb-2 block",
                    error || (field.error && "text-red-500"),
                    labelClassName,
                  )}
                />
              )}

              <FormControl>{renderComponent(formField, error)}</FormControl>
              {field.info && (
                <div
                  dangerouslySetInnerHTML={{ __html: field.info }}
                  className={`text-muted-foreground text-xs font-normal whitespace-pre-wrap`}
                />
              )}
              <FormFieldError field={field} />
              <FormMessage />
            </FormItem>
          );
        }}
      />
    </div>
  );
};
